import React, { useState, useEffect } from 'react';
import './ProgressLoader.css';

interface ProgressLoaderProps {
  message?: string;
  subtitle?: string;
  fullScreen?: boolean;
  className?: string;
}

const ProgressLoader: React.FC<ProgressLoaderProps> = ({
  message = "Loading",
  subtitle = "Please wait while we fetch your content...",
  fullScreen = true,
  className = ""
}) => {
  const [loadingProgress, setLoadingProgress] = useState(0);

  useEffect(() => {
    // Reset progress when component mounts
    setLoadingProgress(0);
    
    // Animate progress with realistic timing
    const progressSteps = [0, 15, 35, 55, 78, 92, 98];
    const timings = [0, 600, 1200, 1800, 2400, 2850, 3000];
    
    const timeouts: NodeJS.Timeout[] = [];
    
    progressSteps.forEach((step, index) => {
      const timeout = setTimeout(() => {
        setLoadingProgress(step);
      }, timings[index]);
      timeouts.push(timeout);
    });

    // Cleanup timeouts on unmount
    return () => {
      timeouts.forEach(timeout => clearTimeout(timeout));
    };
  }, []);

  const containerClass = fullScreen 
    ? `nb-progress-loader-fullscreen ${className}` 
    : `nb-progress-loader-inline ${className}`;

  return (
    <div className={containerClass}>
      <div className="nb-progress-loader-content">
        <div className="nb-progress-loader-text">
          <h3>{message}</h3>
          <p>{subtitle}</p>
        </div>
        <div className="nb-progress-loader-container">
          <div className="nb-progress-loader-bar">
            <div 
              className="nb-progress-loader-fill" 
              style={{ width: `${loadingProgress}%` }}
            ></div>
          </div>
          <div className="nb-progress-loader-percentage">{loadingProgress}%</div>
        </div>
      </div>
    </div>
  );
};

export default ProgressLoader;
